<div class="ag-theme-quartz h-full w-full">
  <ag-grid-angular
    #grid
    class="h-full"
    [rowData]="dataSource"
    [gridOptions]="gridOptions"
    [columnDefs]="colDef"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
